export default __webpack_public_path__ + "static/media/story_introduction.746310fe.png";